import { learnerProfileSchema } from '@mio/shared';
import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from '@/shared/api/client';

export const profileQuery = queryOptions({
  queryKey: ['learner', 'profile'] as const,
  queryFn: ({ signal }) => apiRequest('/me', learnerProfileSchema, { signal }),
  staleTime: 60_000,
});

export function useProfile() {
  return useQuery(profileQuery);
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (displayName: string) =>
      apiRequest('/me', learnerProfileSchema, { method: 'PATCH', body: { displayName } }),
    onSuccess: (profile) => {
      queryClient.setQueryData(profileQuery.queryKey, profile);
      // The overview greets the learner by name.
      void queryClient.invalidateQueries({ queryKey: ['home'] });
    },
  });
}
